import React from "react"
import { useGlobal } from 'reactn'
import { Link } from "gatsby"
import { useState, useEffect } from 'react' 
import IWF from '../components/image-with-fallback'
import posed from 'react-pose'
import Layout from "../components/layout"
import SEO from "../components/seo"
import relationshipIcon from '../images/management-relationship-management-icon.svg'
import projectIcon from '../images/management-project-management-icon.svg'
import assetIcon from '../images/management-asset-management-icon.svg'
import dealIcon from '../images/management-deal-management-icon.svg'

import './management.css'

const AnimationContainer= posed.ul({
  load: {
    x: '0%',
    delayChildren: 200,
    staggerChildren: 50,
    transition: { duration: 200}
  },
  
  static: { 
    x: '-10%',
    delay: 300 },
})

const ManagementPage = () => {

  // global state

  const [showConnectModal, setShowConnectModal] = useGlobal('showConnectModal')

  // local state

  const [animatePage, setAnimatePage] = useState(false)
  
  // effects

  useEffect(() => {
    setAnimatePage(true)
  }, [])
  

  
  return(
  <div className="mobile-wrapper">
    <IWF fileName="artist-management-hero-mobile" className="desktop-background-image"/>
    <Layout location="management">
      <div className="management sub-page">
        <AnimationContainer className="page-animation" pose={animatePage ? 'load' : 'static'}>
        <SEO title="Management" />
        <div className="mobile-top-heading-wrapper">
          <h2 className="top-sub-heading first-sub">ARTIST</h2>
          <h1 className="top-heading">MANAGEMENT</h1>
          {/* <h2 className="top-sub-heading">ON-DEMAND</h2> */}
        </div>  
          <div className="banner-container">
            <IWF fileName="artist-management-banner" className="banner"/>
          </div>
        </AnimationContainer>
          <div className="main-container">
            {/* <div className="main-left">
              <h3 className="marketing-main-links-header">SERVICES</h3>
              <h3 className="marketing-main-links">OUR PROCESS</h3>
              <h3 className="marketing-main-links">OUR RESULTS</h3>
              <h3 className="marketing-main-links">YOUR TEAM</h3>
            </div> */}
            <div className="main">                
              <h1 className="main-heading">THE SERVICES</h1>
              <div className="mobile-main">
                <div className="mobile-the-services-text-block management-services-text-block">
                  <p className="text-block ">
                    We recognize managers as the unsung heroes of the industry. Our modular approach to management services makes it possible for labels and 
                    managers to create sustainable support systems that meet the unique needs of the artists they work with. We can provide immediate 
                    support with deals, collections, administration, and logistics.              
                  </p>
                </div>
              {/* <div className="mobile-development-fixer">                  
              </div> */}
              <div className="row-one mgmt-row-one">
                <div className="box">
                  <div className="icon-aligner aligner-relationship">
                  <div className="icon-padded-room"><img src={relationshipIcon} className="icons relationship-icon"/></div>
                    <h3 className="main-sub-heading">RELATIONSHIP MANAGEMENT</h3>
                  </div>
                  <p className="text-block box-text mobile-text-block">
                    Distributor, Record Label, Publisher, DSP, Agency &amp; Promoter Communications and Hospitality
                  </p>                  
                </div>
                <div className="box">
                  <div className="icon-aligner aligner-project-management">
                  <div className="icon-padded-room project-padded-room"><img src={projectIcon} className="icons project-icon"/></div>
                    <h2 className="main-sub-heading">PROJECT MANAGEMENT</h2>
                  </div>
                  <p className="text-block box-text mobile-text-block">
                    Process Design for Planning, Delegation, Initiation and Execution
                  </p>                  
                </div>
              </div>
              <div className="row-two">
                <div className="box">
                  <div className="icon-aligner aligner-asset">
                  <div className="icon-padded-room"><img src={assetIcon} className="icons asset-icon"/></div>
                    <h2 className="main-sub-heading">ASSET MANAGEMENT</h2>
                  </div>
                  <p className="text-block box-text mobile-text-block">
                    File Management, Metadata Analysis, Catalog Management and Valuation
                  </p>                  
                </div>
                <div className="box">
                  <div className="icon-aligner aligner-deal">
                  <div className="icon-padded-room deal-padded-room"><img src={dealIcon} className="icons data-icon"/></div>
                    <h2 className="main-sub-heading">DEAL MANAGEMENT</h2>
                  </div>
                  <p className="text-block box-text mobile-text-block">
                    Deal Sourcing, Structuring, Negotiation and Revenue Collections
                  </p>                  
                </div>
              </div>
            </div>
            <div className="mobile-process mobile-process-mgmt">              
              <h1 className="main-heading mobile-bottom-heading">THE PROCESS</h1>
              <div className="mgmt-process-text">
                <p className="text-block black-text ">
                  We integrate process driven best practices with catalog, project and relationship management technology to generate actionable business insights. 
                  The core of understanding and executing in the music business, combined with the standards of corporate compliance and modern day technology.
                </p>
              </div>
            </div>          
          </div>

          <IWF fileName="artist-management-the-process" className="process-image mgmt-process-image"/>                                                                                                                    
          <h1 className="main-heading mobile-bottom-heading mgmt-the-results-mobile">THE RESULTS</h1>

          </div>
          <div className="bottom-rectangle management-rectangle">
            <div className="case-study-section management-case-study-section">
              <IWF fileName="artist-management-case-study" className="case-study-image" />
              <div className="case-study-text management-study">
                <h1 className="main-heading mobile-bottom-heading results-study">THE RESULTS</h1>
                <div className="bloodpop-text">
                  <div className="bloodpop-fixer">
                    <span className="case-study-sub-heading">We managed the production of the billion streaming hit record 'Taki Taki' by DJ Snake</span>
                  </div>
                  <p className="text-block management-study-text-block">
                  We lead DJ Snake's management team in the production of his 2nd Billboard #1 Dance album, Carte Blanche, which garnered over 2B plays to date, as well as earning him a record 3 Billion plays on Spotify alone.
                  </p>
                </div>
              </div>
            </div>
          </div> 
        <div className="are-you-ready mgmt-are-you-ready">
          <h1 className="top-heading desktop-rectangle-text">ARE YOU READY?</h1>
          <h1 className="top-heading mobile-rectangle-text ready-one">ARE YOU</h1>
          <h1 className="top-heading mobile-rectangle-text">READY?</h1>          
          <button onClick={() => setShowConnectModal(true)} className="black-button get-started-now cta">CONNECT NOW</button>
        </div>  
      </div>
  </Layout>
</div>
)

}

export default ManagementPage